import { Brand, getBrandByBrandName, isBrand } from '@shared/domain/brand'
import { StoreBrand } from '@shared/gql/document-nodes'

export const brands = [
  Brand.Prisma,
  Brand.SMarket,
  Brand.Herkku,
  Brand.Alepa,
  Brand.Sale,
  Brand.SokosHerkku,
  Brand.MestarinHerkku,
] as const

type ValidBrand = (typeof brands)[number]

const storeBrandMap: Record<ValidBrand, StoreBrand> = {
  [Brand.Herkku]: StoreBrand.Herkku,
  [Brand.SMarket]: StoreBrand.SMarket,
  [Brand.Prisma]: StoreBrand.Prisma,
  [Brand.Alepa]: StoreBrand.Alepa,
  [Brand.Sale]: StoreBrand.Sale,
  [Brand.SokosHerkku]: StoreBrand.SokosHerkku,
  [Brand.MestarinHerkku]: StoreBrand.MestarinHerkku,
}

const isBrandStoreBrand = (brand: Brand): brand is ValidBrand => brand in storeBrandMap

export const storeBrandByBrand = (brandString: string | Brand): StoreBrand | null => {
  if (!isBrand(brandString)) {
    return null
  }

  const brand = getBrandByBrandName(brandString) || Brand.Eprisma

  if (isBrandStoreBrand(brand)) {
    return storeBrandMap[brand]
  }

  return null
}
